

import AxiosAPI from "./AxiosAPI";


export const fetchGetStarted = async (storeID) => {
  try {
    const response = await AxiosAPI.get(`/getstarted?storeID=${storeID}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};